module.exports = __webpack_public_path__ + "static/media/icon-safebox.94972305.svg";